<template>
  <div
    class="tienda-card"
    :class="{ 'tienda-card--cerrada': tmpTienda.Cerrado || !tiendaAbierta(tmpTienda.horarios) }"
  >
    <a
      :href="storeHref"
      class="tienda-card__link"
      @click.prevent="onClickTienda(tmpTienda.Code, tmpTienda.EsFranquicia)"
    >
    <div class="tienda-card__main">
      <div class="tienda-card__avatar">
        <v-img
          v-if="tmpTienda.Img"
          :alt="tmpTienda.Name"
          :src="tmpTienda.Img"
          aspect-ratio="1"
          cover
        ></v-img>
        <div v-else class="tienda-card__avatar-empty">
          <v-icon color="grey lighten-1">mdi-storefront-outline</v-icon>
        </div>
      </div>

      <div class="tienda-card__info">
        <h2 class="tienda-card__name">{{ tmpTienda.Name }}</h2>
        <p v-if="tmpTienda.Address" class="tienda-card__address">{{ tmpTienda.Address }}</p>

        <div class="tienda-card__meta">
          <div v-if="tmpTienda.horarios && tmpTienda.horarios.length > 0" class="meta-row">
            <v-icon x-small color="primary">mdi-clock-outline</v-icon>
            <span>{{ horarioActual(tmpTienda.horarios) }}</span>
          </div>
          <div v-if="tmpTienda.Distancia !== -1 && tmpTienda.Distancia != null" class="meta-row">
            <v-icon x-small color="primary">mdi-map-marker-distance</v-icon>
            <span>{{ formatDistancia(tmpTienda.Distancia) }}</span>
          </div>
        </div>
      </div>
    </div>
    </a>

    <div
      v-if="tmpTienda.Cerrado"
      class="tienda-status tienda-status--warn"
    >
      <v-icon x-small class="mr-1">mdi-lock-outline</v-icon>
      Tienda cerrada
    </div>
    <div
      v-else-if="!tiendaAbierta(tmpTienda.horarios)"
      class="tienda-status tienda-status--info"
    >
      <v-icon x-small class="mr-1">mdi-clock-alert-outline</v-icon>
      {{ textoTiendaCerrada(tmpTienda.horarios) }}
    </div>

    <div class="tienda-card__actions">
      <v-btn
        class="tienda-card__cta"
        color="primary"
        dark
        block
        :href="storeHref"
        :loading="tiendaSeleccionada"
        @click.prevent="onClickTienda(tmpTienda.Code, tmpTienda.EsFranquicia)"
      >
        {{ tmpTienda.EsFranquicia ? 'Ver sucursales' : 'Ver carta' }}
      </v-btn>
    </div>
  </div>
</template>
<script>
import isOpen from '@/helpers/isOpen.js'
import schedules from '@/helpers/schedules.js'
import getNextDate from '@/helpers/getNextDate.js'
import { storePath } from '@/helpers/seoUrls.js'

export default {
  name: 'TiendaCard',
  computed: {
    storeHref () {
      if (!this.tmpTienda || !this.tmpTienda.Code) return '#'
      if (this.tmpTienda.EsFranquicia) {
        return `/sucursales/${encodeURIComponent(String(this.tmpTienda.Code))}`
      }
      return storePath(this.tmpTienda.Code) || '#'
    }
  },
  methods: {
    textoTiendaCerrada (horarios) {
      if (!isOpen(horarios)) {
        const resp = getNextDate(horarios)
        return resp === '' ? 'Fuera de horario' : `Cerrado. ${resp}`
      }
      return ''
    },
    tiendaAbierta (horarios) {
      return isOpen(horarios)
    },
    horarioActual (horarios) {
      return schedules(horarios)
    },
    formatDistancia (m) {
      const n = Number(m)
      if (!Number.isFinite(n) || n < 0) return ''
      if (n >= 1000) return `${(n / 1000).toFixed(1)} km`
      return `${Math.floor(n)} m`
    },
    onClickTienda (code, esFranquicia) {
      this.tiendaSeleccionada = true
      if (this.$store) {
        this.$store.commit('Productos/setProducts', [])
        this.$store.commit('Categorias/setCategoria', null)
      }
      if (esFranquicia) {
        this.$router.push({ name: 'Sucursales', params: { id: code } })
      } else {
        // Entrada directa desde lista de tiendas: no volver a sucursales de otra franquicia.
        if (this.$store) {
          this.$store.dispatch('App/setAppFranquiciaSeleccionada', null)
        }
        this.$router.push({ name: 'Home', params: { client: code } })
      }
    }
  },
  props: {
    tienda: {
      type: Object
    }
  },
  created () {
    this.tmpTienda = { ...this.tienda }
  },
  data () {
    return {
      tiendaSeleccionada: false,
      tmpTienda: {}
    }
  }
}
</script>

<style scoped>
.tienda-card {
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 14px;
  padding: 14px 16px 12px;
  margin: 0 auto 12px;
  max-width: 520px;
  text-align: left;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}
.tienda-card__link {
  display: block;
  color: inherit;
  text-decoration: none;
}
.tienda-card--cerrada {
  opacity: 0.92;
}
.tienda-card__main {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}
.tienda-card__avatar {
  flex: 0 0 72px;
  width: 72px;
  height: 72px;
  border-radius: 12px;
  overflow: hidden;
  background: #f3f3f3;
  border: 1px solid #efefef;
}
.tienda-card__avatar-empty {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tienda-card__info {
  flex: 1;
  min-width: 0;
}
.tienda-card__name {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 800;
  line-height: 1.25;
  color: rgba(0, 0, 0, 0.87);
}
.tienda-card__address {
  margin: 4px 0 0;
  font-size: 0.85rem;
  line-height: 1.35;
  color: rgba(0, 0, 0, 0.55);
}
.tienda-card__meta {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.meta-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.65);
}
.tienda-status {
  display: flex;
  align-items: center;
  margin-top: 10px;
  padding: 8px 10px;
  border-radius: 10px;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.3;
}
.tienda-status--warn {
  background: #fff8e1;
  color: #8a6d00;
}
.tienda-status--info {
  background: #f5f5f5;
  color: rgba(0, 0, 0, 0.65);
}
.tienda-card__actions {
  margin-top: 12px;
}
.tienda-card__cta {
  height: 44px !important;
  border-radius: 12px !important;
  text-transform: none !important;
  letter-spacing: 0.02em !important;
  font-weight: 700 !important;
  color: #fff !important;
}
</style>
